import React, { useState } from 'react'
import { Button, Input, Form } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import intl from 'react-intl-universal'
import './index.scss'
import PasswordStrength from '@/components/passwordStrength'
import { getPasswordFirstError } from '@/components/passwordStrength/utils'
import { useLoginStore } from '@/store/loginStore'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LOGIN_PATH } from '@/routers/login' 
import { weComLogin } from '@/services/login'
import { loginSuccess } from '@/utils/utils'

const lang = localStorage.getItem('lang') || 'zh-CN'
const isEnUS = lang === 'en-US'

const AddUserInfo = () => {
  const { thirdInfo, setShowAddInfo } = useLoginStore()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [loading, setLoading] = useState(false)

  const [form] = Form.useForm()

  const [passwordFocused, setPasswordFocused] = useState(false)

  const hasSpace = (rule, value, callback) => {
    if (value) {
      const reg = /^\s+|\s+$/g
      if (reg.test(value)) {
        return callback(new Error(intl.get('login.noSpace')))
      }
    }
    callback()
  }

  const validatePasswordStrength = (rule, value, callback) => {
    const error = getPasswordFirstError(value, 'LOW', 6, 18)
    if (error) {
      return callback(new Error(error))
    }
    callback()
  }

  const isSamePwd = (rule, value, callback) => {
    const password = form.getFieldValue('password')
    if (value) {
      if (password !== value) {
        return callback(new Error(intl.get('login.psdsNotMatch')))
      }
    }
    callback()
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)
      const fieldsValue = await form.validateFields()
      const res = await weComLogin({
        authCode: searchParams.get('code'),
        corpId: thirdInfo?.corpId,
        qwUserId: thirdInfo?.qwUserId,
        account: fieldsValue.account,
        password: fieldsValue.password,
        email: fieldsValue.email,
        mobile: fieldsValue.phone,
      })
      loginSuccess(res.loginResponse)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const onBack = () => {
    setShowAddInfo(false)
    navigate(LOGIN_PATH)
    setSearchParams({})
  }

  return (
    <div className='addUserInfo-wrapper'>
      <div className={`addUserInfo-title`}>
        <ArrowLeftOutlined onClick={onBack} />
        {intl.get('login.personInfo')}
      </div>
      <div className={`addUserInfo-msg ${isEnUS ? 'enMsg' : ''}`}>{intl.get('login.personInfoMsg')}</div>
      <Form layout='vertical' className='addUserInfo-form' form={form}>
        {/* 手机号 */}
        <Form.Item className='addUserInfo-item' label={intl.get('login.phoneNumber')}
          name="phone"
          rules={[{
            required: true,
            message: intl.get('login.pleaseInputThePhoneNumber')
          },
          {
            pattern: /^1(3|4|5|6|7|8|9)([0-9]{9})/,
            message: intl.get('login.pleaseInputACorrectPhoneNumber')
          },
          { validator: hasSpace }
          ]}
        >
          <Input placeholder={intl.get('login.pleaseInputThePhoneNumber')} />
        </Form.Item>
        {/* 邮箱 */}
        <Form.Item className='addUserInfo-item' label={intl.get('login.email')}
          name="email"
          rules={[{
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5._]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: intl.get('login.placeInputACorrectEmail')
          },
          { validator: hasSpace }
          ]}
        >
          <Input placeholder={intl.get('login.placeInputEmail')} />
        </Form.Item>
        {/* 账号 */}
        <Form.Item className='addUserInfo-item' label={intl.get('login.inputAccount')}
          name="account"
          rules={[{
            required: true,
            message: intl.get('login.pleaseInputYourAccount')
          },
          { validator: hasSpace }
          ]}
        >
          <Input placeholder={intl.get('login.pleaseInputYourAccount')} />
        </Form.Item>
        {/* 密码 */}
        <Form.Item className='addUserInfo-item' label={intl.get('login.password')}
          name="password"
          rules={[{
            required: true,
            message: intl.get('login.placeInputPassword')
          },
          { validator: hasSpace },
          { validator: validatePasswordStrength }
          ]}
        >
          <Input.Password
            placeholder={intl.get('login.placeInputPassword')}
            autoComplete='new-password'
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
          />
        </Form.Item>
        {/* 密码强度 */}
        <div className={`addUserInfo-passwordStrength-wrapper ${passwordFocused ? 'expanded' : ''}`}>
          <PasswordStrength
            passwordLevel={'LOW'}
            value={form.getFieldValue('password')}
            min={6}
            max={18}
            className='addUserInfo-passwordStrength'
          />
        </div>
        {/* 二次确认密码 */}
        <Form.Item className='addUserInfo-item' label={intl.get('login.confirmPwd')}
          name="copyPassword"
          rules={[{
            required: true,
            message: intl.get('login.psdsNotMatch')
          },
          { validator: isSamePwd },
          { validator: hasSpace }
          ]}
        >
          <Input.Password placeholder={intl.get('login.confirmPwd')} />
        </Form.Item>
      </Form>
      <Button className='addUserInfo-btn' loading={loading} type='primary' onClick={handleSubmit}>{intl.get('login.Confirm')}</Button>
    </div>
  )
}

export default AddUserInfo